import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../../common/error'

import { Error } from 'components/Error'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const [t] = useTranslation(['payments'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        // TODO: Add error codes
        default:
      }
    }

    return <Error message={t('errors.failedToLoadPaymentInfo')} />
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
